var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPieChartIcon = function SvgPieChartIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27.813,
    height: 27.813,
    viewBox: "0 0 27.813 27.813",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chart",
    transform: "translate(-1221.939 -135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10018",
    "data-name": "Group 10018",
    transform: "translate(1221.939 135)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Intersection_1",
    "data-name": "Intersection 1",
    d: "M0,13.376V0H.448A13.385,13.385,0,0,1,13.376,12.922v.454Z",
    transform: "translate(14.437 0)",
    fill: "#f59064"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M13.41,26.821A13.414,13.414,0,0,1,8.19,1.054,13.326,13.326,0,0,1,13.41,0c.149,0,.3,0,.448.007H13.41v13.4h13.4v-.455c.005.157.008.31.008.455a13.4,13.4,0,0,1-13.41,13.41Z",
    transform: "translate(0 0.993)",
    fill: "#3953fb"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPieChartIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pieChartIcon.80d8ab24.svg";
export { ForwardRef as ReactComponent };